import Cookies from 'js-cookie';


const hideCookieTimeLength = 24*7; //7 day (in hours)
class Toast {
    constructor(el) {
        this.el = el;
        this.closeEl = el.find('.toast__close');
        this.lastUpdated = el.data('lastUpdated');
        this.hideTime = (el.data('hideTime') || hideCookieTimeLength) * 1000*60*60;

        /**
         * Events
         */

        this.closeEl.click((() => {
            Cookies.set('hide_alert_toaster', this.lastUpdated, {
                expires: new Date(new Date().getTime() + this.hideTime)
            });
            this.close();
        }).bind(this));

        if (!Cookies.get('hide_alert_toaster') ||
            Cookies.get('hide_alert_toaster') !== this.lastUpdated) {
            Cookies.remove('hide_alert_toaster');
            this.el.show();
        }
    }

    open() {
        this.el.slideDown(200);
    }

    close() {
        this.el.slideUp(200);
    }
}

export default Toast;